var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "w-100 h-100", class: _vm.notch ? "hasNotch" : "" },
    [
      _c(
        "div",
        { staticClass: "container-md pb-5", attrs: { id: "app-container" } },
        [
          _c(
            "div",
            {
              staticClass: "text-center text-lg-right sticky-top",
              on: {
                click: function($event) {
                  return _vm.top()
                }
              }
            },
            [_c("div", { staticClass: "logo my-3", attrs: { rel: "preload" } })]
          ),
          _vm._v(" "),
          this.user || this.$route.name == "Login"
            ? _c("router-view", {
                staticClass: "router",
                class: "page-" + _vm.$page,
                attrs: {
                  class: _vm.$page != "Home" ? "sticky" : "",
                  user: _vm.user,
                  page: _vm.$page
                },
                on: { user: _vm.setUser }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      this.$alert
        ? _c(
            "div",
            {
              staticClass: "alert global-alert alert-dismissible fade show",
              class: this.$alert.type
                ? "alert-" + this.$alert.type
                : "alert-dark"
            },
            [
              this.$alert.title
                ? _c("div", { staticClass: "alert-heading text-center" }, [
                    _vm._v(_vm._s(this.$alert.title))
                  ])
                : _vm._e(),
              _vm._v("\n        " + _vm._s(this.$alert.message) + "\n    ")
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showDialog
        ? _c(
            "div",
            {
              staticClass: "alert alert-primary fixed-bottom mb-5",
              attrs: { id: "notification" },
              on: { click: _vm.reload }
            },
            [
              _vm._v("A new version of this app is available. Click "),
              _c("a", { attrs: { id: "reload" } }, [_vm._v("here")]),
              _vm._v(" to update.")
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      !this.$authenticated
        ? _c("div", [
            _c("div", { staticClass: "wave water" }),
            _vm._v(" "),
            _c("div", { staticClass: "wave water" }),
            _vm._v(" "),
            _c("div", { staticClass: "wave water" }),
            _vm._v(" "),
            _c("div", { staticClass: "wave water" })
          ])
        : _vm._e(),
      _vm._v(" "),
      this.$authenticated
        ? _c("Footer", { attrs: { user: _vm.user, page: "page" } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 